import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state:{
		pr_Code:'' ,//项目id
		s_Code:'',//样本id
		pindex:'',//中断页
		projectinfo:{}, //项目
		/** 禁止修改拨打电话 */
		forbid_up_phone:'',
		/** 隐藏电话 */
		hide_phone:'',
		/** 是否启用拨打控制 */
		dial_control:'',
		/** 最多拨打次数 */
		most_dialnum:'',
		/** 修改扩展信息 */
		alert_sample:'',
		
    }
})
export default store